import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { AuthLoginGuard } from './guard/auth-login.guard';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { NdgInsertComponent } from './landing-page/ndg-insert/ndg-insert.component';
import { NdgInsertGuard } from './guard/ndg-insert.guard';
import { SurveyComponent } from './landing-page/survey/survey.component';
import { ShowAnagComponent } from './landing-page/survey/show-anag/show-anag.component';
import { InternalComponent } from './landing-page/survey/new/internal/internal.component';
import { ShowComponent } from './landing-page/survey/show/show.component';
import { ExternalComponent } from './landing-page/survey/new/external/external.component';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule), canActivate: [AuthLoginGuard] },
  { path: '', component: LandingPageComponent, canActivate: [AuthGuard], children: [
    { path: 'ndg/insert', component: NdgInsertComponent, canActivate: [NdgInsertGuard] },
    { path: 'survey/:ndg', component: SurveyComponent, children: [
      { path: 'anag', component: ShowAnagComponent },
      { path: 'new', component: InternalComponent },
      { path: ':surveyId', component: ShowComponent },
      { path: '', redirectTo: 'anag', pathMatch: 'full' }
    ]},
    { path: 'survey', redirectTo: 'survey/search' }
  ]},
  { path: 'external', component: ExternalComponent },

  { path: '**', redirectTo: '/survey/search', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
